import AbstractApiModel from '@/models/abstracts/AbstractApiModel';

/** POST /team_status_histories {team, teamStatus} : archivage / réactivation d'une équipe (archiver la vide de ses membres) */
export default class TeamStatusHistoryModel extends AbstractApiModel {
  protected _path = '/team_status_histories/{?id}';
}
